import {
  extraErrorDataIntegration,
  httpClientIntegration,
  init,
  replayIntegration,
} from '@sentry/react';
import { env } from 'env';
import React from 'react';
import { createRoot } from 'react-dom/client';

import App from './App';
import { POSTHOG_PROXY_PATH } from './lib/posthog-proxy';

// PostHog is same-origin behind the proxy, so matching on its host no longer works.
const IGNORED_BREADCRUMB_FETCH_URLS = ['posthog.com', POSTHOG_PROXY_PATH];

// Initialize Sentry
if (env.VITE_SENTRY_DSN) {
  init({
    // Disable sentry in development
    enabled: import.meta.env.PROD,

    dsn: env.VITE_SENTRY_DSN,
    environment: env.VITE_ENVIRONMENT || import.meta.env.MODE,

    // Adjust this value in production, or use tracesSampler for greater control
    tracesSampleRate: 0.1,

    // Setting this option to true will print useful information to the console while you're setting up Sentry.
    debug: false,

    replaysOnErrorSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,

    sendDefaultPii: true,

    beforeBreadcrumb(breadcrumb) {
      const isFetch =
        breadcrumb.category === 'fetch' || breadcrumb.category === 'xhr';

      if (
        isFetch &&
        IGNORED_BREADCRUMB_FETCH_URLS.some((url) =>
          (breadcrumb.data?.url as string)?.includes(url),
        )
      ) {
        return null;
      }

      return breadcrumb;
    },

    integrations: [
      httpClientIntegration(),
      extraErrorDataIntegration(),
      replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
  });
}

createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
